var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeerbitLogoBoxedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V34H36V0Z",
    fill: "#E4E7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36572 5.05762V19.3879H30.6279V5.05762H5.36572ZM25.8016 14.6159H10.277V9.84152H25.8016V14.6159Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36572 24.1689H30.6279V27.1497C30.6276 27.6235 30.4387 28.078 30.1025 28.4139C29.7662 28.7497 29.31 28.9396 28.8333 28.9421H5.36572V24.1689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeerbitLogoBoxedGrey);
export default __webpack_public_path__ + "static/media/seerbit_logo_boxed_grey.b190e5c0babe5154de531d4c86733de9.svg";
export { ForwardRef as ReactComponent };